/**
 * Who the storage over-limit banner and the over-limit toast address as the
 * people responsible for the workspace's storage. Shared so the two surfaces
 * can never disagree about who is told "this workspace is over" versus
 * "contact your workspace admin".
 *
 * This is role-based because it matches who the over-limit notification is
 * sent to (owners and admins). Whether someone may actually CHANGE storage
 * settings is a separate question, answered by the `manage-org` slug.
 */

import type { Me } from '@/api/types-bridge'

export function isStorageAudience(me: Me | undefined): boolean {
  const role = me?.membership?.role
  return role === 'owner' || role === 'admin'
}
